(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["micrositepagepilingscripts"] = factory();
	else
		root["Site"] = root["Site"] || {}, root["Site"]["micrositepagepilingscripts"] = factory();
})(self, () => {
return 